import React from 'react';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const navigateToJobs = () => {
    window.location.href = '/jobs';
  };

  const navigateHome = () => {
    window.location.href = '/';
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/4915216817165', '_blank');
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 text-white relative">
      {/* Wave Top */}
      <div className="absolute top-0 left-0 right-0 -translate-y-[99%]">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 80C240 30 480 0 720 20C960 40 1200 70 1440 50V80H0Z" fill="rgb(15 23 42)"/>
        </svg>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        {/* Large Logo at Top */}
        <div className="text-center mb-12 pb-12 border-b border-gray-700">
          <img 
            src="/images/davinci-logo-new.png" 
            alt="Da Vinci Institut" 
            className="h-32 md:h-40 mx-auto opacity-90 cursor-pointer hover:opacity-100 transition-opacity bg-white rounded-2xl p-4"
            onClick={navigateHome}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-teal-400">Da Vinci Institut</h3>
            <p className="text-gray-300 leading-relaxed">
              Professionelle Nachhilfe und Sprachförderung von der 1. Klasse bis zum Abitur. 
              Unsere geschulten Dozenten sind examinierte Lehrkräfte mit Expertise und Leidenschaft.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Schnellzugriff</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('courses')}
                  className="text-gray-300 hover:text-teal-400 transition-colors duration-200"
                >
                  Unsere Leistungen
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-teal-400 transition-colors duration-200"
                >
                  Über uns
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-teal-400 transition-colors duration-200"
                >
                  Kontakt
                </button>
              </li>
              <li>
                <button
                  onClick={navigateToJobs}
                  className="text-gray-300 hover:text-teal-400 transition-colors duration-200"
                >
                  Jobs für Dozenten
                </button>
              </li>
              <li>
                <button
                  onClick={openWhatsApp}
                  className="text-gray-300 hover:text-teal-400 transition-colors duration-200 flex items-center gap-2"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-teal-400 mt-1 flex-shrink-0" />
                <a href="mailto:info@davinci-institut.de" className="text-gray-300 hover:text-teal-400 transition-colors">info@davinci-institut.de</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-teal-400 mt-1 flex-shrink-0" />
                <a href="tel:+4915216817165" className="text-gray-300 hover:text-teal-400 transition-colors">+49 152 16817165</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-teal-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300">Quettinghofstraße 47C<br />50769 Köln</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Da Vinci Institut. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <button 
                onClick={() => window.location.href = '/datenschutz'}
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
              >
                Datenschutz
              </button>
              <button 
                onClick={() => window.location.href = '/impressum'}
                className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
              >
                Impressum
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
